import React from "react";
import { Card, Grid, Box, Typography } from "@mui/material";
import UserLevelChip from "../level/UserLevelChip";

const StatBlock = ({ value, label }) => {
  const truncateWords = (text) => {
    return text.split(' ').map(word =>
      word.length > 8 ? `${word.slice(0, 8)}` : word
    ).join(' ');
  };

  return (
    <Grid container direction="column" spacing={0} alignItems="center">
      <Grid item>
        <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1.5rem', color: 'primary.main' }}>
          {value}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {truncateWords(label)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default function ProfileTopBlock({ user, userLevelStats, userLevel }) {
  return (
    <Card sx={{ mb: 2, p: 2 }}>
      <Grid container spacing={1} >
        <Grid item xs={1}>
          <Box
            sx={{
              width: 60,
              height: 60,
              backgroundImage: 'url(/assets/icons/xp-level-badge.svg)',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: 'white',
                fontWeight: 'bold',
                textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
              }}
            >
              {user.xpDetails.level.name || "?"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <UserLevelChip level={user.userLevelStats.topPct} />
            </Grid>
            <Grid item>
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                Player Value
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <StatBlock value={`${userLevelStats.topPct || 0}%`} label="Top" />
        </Grid>
        <Grid item xs={1}>
          <Box
            sx={{
              width: '1px',
              height: '60px',
              backgroundColor: 'divider',
              margin: '0 auto',
            }}
          />
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={1} >
            {userLevelStats && userLevelStats.map((stat, index) => (
              <Grid item xs={2} key={index}>
                <StatBlock value={`${stat.topPct || 0}%`} label={stat.name} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Card >

  );
}
